import React, { useState } from 'react';

import { Radio } from 'antd';
import { T } from 'react-translator-component';

import { ConnectionsTab, ConnectionsTabProps } from './ConnectionsTab';
import { MapTab, MapTabProps } from './MapTab';

import { ViewSwitch } from '../styled';

export type ConnectionsPaneProps = ConnectionsTabProps & {
  map: Omit<MapTabProps, 'tenantId' | 'connections'>;
};

/**
 * Conexões, com o mapa de ligações dentro (MV2-1706).
 *
 * O mapa era aba própria e falava do mesmo assunto: quais contratos existem e com quem. Duas
 * abas para a mesma pergunta obrigavam a escolher antes de saber qual das duas responde —
 * agora é uma aba com duas formas de olhar.
 *
 * O alternador vive DENTRO da barra de filtro, como o Lista/Mapa da aba Estações. Isso não é
 * só posição: a barra fica visível nas duas visões, e por isso o mapa recebe os contratos já
 * filtrados. Barra de filtro à mostra que não filtra o que está na tela é pior do que barra
 * nenhuma.
 */
export const ConnectionsPane: React.FC<ConnectionsPaneProps> = ({ map, ...connections }) => {
  const [view, setView] = useState<'contracts' | 'map'>('contracts');

  return (
    <ConnectionsTab
      {...connections}
      viewSwitch={
        <ViewSwitch
          value={view}
          size="small"
          buttonStyle="solid"
          onChange={(event) => setView(event.target.value)}
        >
          <Radio.Button value="contracts">{T('List')}</Radio.Button>
          <Radio.Button value="map">{T('Diagram')}</Radio.Button>
        </ViewSwitch>
      }
      mapView={
        view === 'map'
          ? (filtered) => (
              <MapTab tenantId={connections.tenantId} connections={filtered} {...map} />
            )
          : undefined
      }
    />
  );
};
